/**
@license
Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
import "@polymer/polymer/polymer-legacy.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "./shared-styles.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
class ErrorPage extends PolymerElement {
    static get template() {
        return html `
            <style include="shared-styles">
                :host {
                    display: block;
                    padding: 10px;
                    height: calc(100vh - 20px);
                    background: -webkit-linear-gradient(
                        225deg,
                        #233d44,
                        #1f4144
                    );
                }

                #header {
                    padding-left: 25px;
                    margin-top: 10px;
                    text-align: center;
                }

                #error-container {
                    color: white;
                    font-size: 24px;
                    position: absolute;
                    margin: auto;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    height: 200px;
                    text-align: center;
                }

                #errorNo {
                    font-size: 48px;
                    font-weight: 900;
                    text-align: center;
                }

                .errorMessage {
                    text-align: center;
                }

                #logo {
                    padding-right: 50px;
                    width: 300px;
                }

                .text {
                    font-size: 16px;
                    text-align: center;
                }

                a {
                    color: #eeeeee;
                }
            </style>

            <div class="container">
                <div id="header">
                    <img id="logo" src="images/SiteSeeLarge.png" />
                </div>
                <div id="error-container">
                    <template is="dom-if" if="{{error.code}}">
                        <p id="errorNo" style="margin: 0">[[error.code]]</p>
                    </template>

                    <p class="errorMessage" style="margin: 0">[[message]]</p>

                    <p class="text">
                        <a
                            style="text-decoration: underline; cursor: pointer;"
                            onclick="window.location.reload()"
                            >Refresh</a
                        >
                        the page, go back to <a href="/">home</a> or try
                        <a href="/logout">logging out</a>
                    </p>
                    <template is="dom-if" if="{{error.error.trackingId}}">
                        <p class="trackingId">Id: [[error.error.trackingId]]</p>
                    </template>
                </div>
            </div>
        `;
    }
    static get is() {
        return "error-page";
    }
    static get properties() {
        return {
            message: String,
            error: {
                type: Object,
                value: {
                    message: "An unexpected error occurred.",
                },
                observer: "_errorChanged",
            },
        };
    }
    _errorChanged() {
        // this.message = ErrorPage.getErrorMessage(this.error);
        if (!this.error) {
            return;
        }
        if (this.error.error && !this.error.message) {
            this.error.message = this.error.error;
        }
        if (this.error && this.error.code) {
            switch (this.error.code) {
                case 401:
                    // Force clear token if there
                    // this.error = undefined;
                    this.dispatchEvent(new CustomEvent("changeRoute", {
                        bubbles: true,
                        composed: true,
                        detail: {
                            route: "/login",
                            params: {
                                redirect_uri: `${window.location}`,
                            },
                            errorMessage: "You are unauthenticated.\nPlease login or register to continue.",
                        },
                    }));
                    return;
                default:
                    break;
                // For any other errors do nothing (we just stay on the error page)
            }
        }
        this.message = ErrorPage.getErrorMessage(this.error);
    }
    static getErrorMessage(error) {
        if (error &&
            error.message &&
            Object.prototype.toString.call(error.message) === "[object String]") {
            return error.message;
        }
        if (error && error.message && error.message.error) {
            return error.message.error;
        }
        return "An unexpected error occurred.";
    }
    ready() {
        super.ready();
    }
}
window.customElements.define(ErrorPage.is, ErrorPage);
//# sourceMappingURL=error.js.map